import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Menderes Mahallesi Halı Yıkama",
    path: "/esenler/menderes-hali-yikama",
    description:
      "Menderes Mahallesi’nde halılarınız tam otomatik makinelerde yıkanır, aynı gün teslim garantisiyle sunulur."
  },
  {
    label: "Kazım Karabekir Mahallesi Halı Yıkama",
    path: "/esenler/kazim-karabekir-hali-yikama",
    description:
      "Kazım Karabekir Mahallesi'nde antibakteriyel ürünlerle sağlıklı ve hijyenik halı yıkama hizmeti sağlıyoruz."
  },
  {
    label: "Fevzi Çakmak Mahallesi Halı Yıkama",
    path: "/esenler/fevzi-cakmak-hali-yikama",
    description:
      "Fevzi Çakmak Mahallesi’nde halılarınız özenle temizlenir, kapıdan alım ve teslim ücretsizdir."
  },
  {
    label: "Tuna Mahallesi Halı Yıkama",
    path: "/esenler/tuna-hali-yikama",
    description:
      "Tuna Mahallesi’nde bireysel ve kurumsal müşterilere yönelik hızlı ve garantili halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Havaalanı Mahallesi Halı Yıkama",
    path: "/esenler/havaalani-hali-yikama",
    description:
      "Havaalanı Mahallesi’nde halılarınızı profesyonel kadromuz ve modern makinelerimizle yıkıyoruz."
  },
  {
    label: "Birlik Mahallesi Halı Yıkama",
    path: "/esenler/birlik-hali-yikama",
    description:
      "Birlik Mahallesi’ne özel halı yıkama servisimiz, çevre dostu ve güvenilir temizlik çözümleri sunar."
  },
  {
    label: "Yavuz Selim Mahallesi Halı Yıkama",
    path: "/esenler/yavuz-selim-hali-yikama",
    description:
      "Yavuz Selim Mahallesi'nde halılarınız hijyenik, hızlı ve garantili bir şekilde yıkanır ve teslim edilir."
  }
];

const EsenlerSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">ESENLER SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EsenlerSidebar;
